export default __webpack_public_path__ + "static/dons-f6cdc6e51c6ff6844c91e26b435d9c34.jpg";